export const MuiTable = {
    defaultProps: {
        size: 'small'
    }
};

//# sourceMappingURL=table.js.map